export default {
  'home-title': 'test',
  'home-title-drone': 'Drone Pilot',
  'home-title-company': 'Company',
  'home-title-tenant': 'Tenant',
  'home-title-sony': 'SONY',
}